import { render, staticRenderFns } from "./orderPayOff.vue?vue&type=template&id=23f5a8c7&scoped=true"
import script from "./orderPayOff.vue?vue&type=script&lang=js"
export * from "./orderPayOff.vue?vue&type=script&lang=js"
import style0 from "./orderPayOff.vue?vue&type=style&index=0&id=23f5a8c7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f5a8c7",
  null
  
)

export default component.exports